import { StyleSheet } from 'react-native';
import { IToggle } from '@nocode/types';

const createStyles = (props: IToggle) => {
  return StyleSheet.create({
    icon: {
      width: props.width || props.attributes.size,
      height: props.height || props.attributes.size,
      margin: 0,
    },
  });
};

export default createStyles;
